import ons from 'onsenui';

function loadPage({page, parent, params = {}}, done) {
  var element = document.getElementById(page)
  element.style.display = ''
  parent.appendChild(element);
  done(element);
}

function unloadPage(element) {
  var parent = document.getElementById('templates')
  parent.appendChild(element)
}

const domLoader = new ons.PageLoader(loadPage, unloadPage)

ons.domLoader = domLoader

export default domLoader
